import styled from 'styled-components';
import BaseCancelButton from 'shared/ui/CancelButton';

export const Wrapper = styled.div`
  margin-bottom: 13px;
  justify-content: ${({ $hasTitle }) => ($hasTitle ? 'space-between' : 'flex-end')};
  align-items: center;
  display: flex;
  padding: 0px;
`;
Wrapper.displayName = 'Wrapper';

export const Title = styled.div`
  font-size: 21.5px;
  font-weight: 600;
  line-height: 0.84;
  color: ${({ theme }) => theme.text.settingsBlueTitle};
  text-align: initial;
`;
Title.displayName = 'Title';

export const Actions = styled.div`
  display: flex;
  & > *:not(:last-child) {
    margin-right: 5px;
  }
`;
Actions.displayName = 'Actions';

export const CancelButton = styled(BaseCancelButton)`
  background-color: transparent;
`;
CancelButton.displayName = 'CancelButton';
